import React, { useState } from 'react';
import { Link, useLocation, NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './templateheader.css';
import { faUser } from '@fortawesome/free-regular-svg-icons';

const Header = ({ setViewMode }) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [mobileNavOpen, setMobileNavOpen] = useState(false);
    const location = useLocation();
    const [path, setPath] = useState(location.pathname);

    const handleNavToggle = () => setMobileNavOpen(open => !open);
    const handleNavLinkClick = () => setMobileNavOpen(false);

    // Show "Get Template" if on a template preview route, but NOT on the main type pages
    const isTemplatePreview =
        /^\/(agent|brokerage|landing)-/.test(location.pathname) &&
        !/^\/(agent-templates|brokerage-templates|landing-pages)(\/|$)/.test(location.pathname);

    return (
        <header className="main-header">
            <div className="header-left">
                <Link to="/" className="logo-link" onClick={handleNavLinkClick}>
                    <img
                        src={require('../../assets/imgs/aptowebsiteslogo.png')}
                        alt="Apto Websites Logo"
                        className="logo"
                    />
                </Link>
                {/* <span className="header-title-mobile">Apto Websites</span> */}
            </div>

            <nav className={`nav-menu${mobileNavOpen ? ' open' : ''}`}>
                {/* <Link to="/" className="nav-link" onClick={handleNavLinkClick}>Information</Link> */}
                <NavLink
                    to="/templates"
                    className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
                    onClick={handleNavLinkClick}
                    tabIndex={0}
                >
                    Templates
                </NavLink>
                <NavLink to="/socials"
                    className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
                    onClick={handleNavLinkClick}>Social Media</NavLink>
                {/* <Link to="/signup" className="nav-link" onClick={handleNavLinkClick}>Get Started</Link> */}
                {!isTemplatePreview && (
                    <NavLink to="/pricing"
                        className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
                        onClick={handleNavLinkClick}>Pricing</NavLink>
                )}
                {isTemplatePreview && (
                    <Link
                        to="/pricing"
                        className="get-template-btn"
                        onClick={handleNavLinkClick}
                    >
                        Get Template
                    </Link>
                )}
            </nav>

            <Link
                className="signup-btn primary"
                to='/signup'
                aria-label="Sign Up"
            >
                <FontAwesomeIcon icon={faUser} className='user-icon' />
                Sign Up
            </Link>

            <button
                className={`mobile-nav-toggle${mobileNavOpen ? ' open' : ''}`}
                onClick={handleNavToggle}
                aria-label="Toggle navigation"
            >
                <span className="hamburger"></span>
                <span className="hamburger"></span>
                <span className="hamburger"></span>
            </button>
        </header>
    );
};

export default Header;
